import { DIRECTION_COLOR, DIRECTION_GLYPH, directionOf } from '../insightsData.js'
import { formatMovement } from '../labels.js'
import type { HeadlineKey } from '../types.js'

/** A figure's change since the month before, as a glyph and a signed number: coral only when it is worse, never colour alone. */
export function MovementBadge({ metric, movement, suffix = '', className = '' }: { metric: HeadlineKey; movement: number | null; suffix?: string; className?: string }) {
  const direction = directionOf(metric, movement, 0.05)
  if (direction === null) {
    return <span className={`text-[11px] text-ink-mid ${className}`}>—</span>
  }
  return (
    <span className={`inline-flex items-center gap-1 text-[11px] font-bold ${className}`} style={{ color: DIRECTION_COLOR[direction] }}>
      <span aria-hidden="true">{DIRECTION_GLYPH[direction]}</span>
      <span>
        {formatMovement(metric, movement)}
        {suffix}
      </span>
      <span className="sr-only">{direction === 'up' ? 'better' : direction === 'down' ? 'worse' : 'unchanged'}</span>
    </span>
  )
}
